import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  itemsContainer: {
    display: 'grid',
    gridRowGap: '0.625rem',
    gridAutoRows: 'min-content',
    margin: '0 0 0.625rem 0',
    scrollbarWidth: 'thin',
    overflowY: 'auto',
  },
  root: {
    alignContent: 'space-between',
    background: neutral.white,
    display: 'grid',
  },
});
